/**
 * View full image or video block.
 * @module components/Blocks/FullImage/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Container } from 'semantic-ui-react';
import { ButtonLink, ImageFromUrl } from '~/components';
import LeadVideo from '@package/components/LeadVideo/LeadVideo';

/**
 * View image block class.
 * @class View
 * @extends Component
 */

const View = ({ data, detached, id }) => {
  const videoPoster =
    data.video_poster?.[0]?.image?.scales?.leadimage?.download;
  const video = data.video?.[0];
  const videoUrl = video
    ? video.file?.download ?? video.getURL + '/@@download/file'
    : null;
  const videoMimeType = video?.file?.['content-type'] ?? video?.mime_type;
  const videoID = video ? video?.UID + id : null;

  const overlayText =
    data.title || data.description || data.href ? (
      <div className="overlay-text">
        <Container>
          {data.title ? <div className="title">{data.title}</div> : null}
          {data.description ? (
            <div className="description mobile hidden">{data.description}</div>
          ) : null}

          <ButtonLink
            to={data.href}
            title={data.linkTitle}
            targetBlank={data.openLinkInNewTab}
            color={data.buttonLinkColor}
            showArrow={data.showArrowOnLink}
            _className={data.buttonLinkAlign}
          />
        </Container>
      </div>
    ) : null;

  return (
    <div
      className={cx('block fullImage', {
        detached,
      })}
    >
      {(data.url || data.video) && (
        <div
          className={cx(
            {
              'full-width': data.align === 'full',
              'bg-video': data.bgType === 'video',
            },
            data.size,
          )}
        >
          {data.bgType === 'video' ? (
            <LeadVideo
              id={videoID}
              poster={videoPoster}
              mimeType={videoMimeType}
              url={videoUrl}
            />
          ) : (
            <>
              {/*----------------IMMAGINE----------------*/}
              {data.url && (
                <ImageFromUrl
                  url={data.url}
                  className="bg"
                  title={data.alt || ''}
                  size="leadimage"
                />
              )}
            </>
          )}

          {/*----------------OVERLAY TEXT----------------*/}
          {overlayText}
        </div>
      )}
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
